import React, { useEffect } from "react";
import { useTitle } from "../provider/TitleProvider";

const FAQ = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle("Frequently asked questions");
  }, []);

  return (
    <div className="auto-container">
      <div className="row clearfix">
        <h4>How does Fintree work?</h4>
        <p>
          Fintree, helps with money you need now or over the short term, for things like your deposit, your home loan
          repayments are the budget for your dream home that is just a little beyond your reach. In exchange for this,
          we take synthetic equity or a share in your home. Synthetic means that we are not on the title of the home,
          only you are, but you have signed a contract agreeing to buy out our share in the future when it is
          affordable, or to give us a share if you sell.
        </p>
        <h4>How much share do you take?</h4>
        <p>
          How much share we take depends on home much money we give you and how much the property is worth. Generally,
          the capital gains from just one year in your home, will overshadow the share we take.
        </p>
        <h4>How will I be able to afford to repurchase your share?</h4>
        <p>
          We have different options whereby you can pay a small amount monthly, or buy us out all at once with a
          refinance of your homeloan. Over time many factors generally make this very feasible – your property will
          generally appreciate each year, your wages should grow over time, rates are expected to come down etc.
        </p>
        <h4>If I can’t afford to buy out your share will I lose my home?</h4>
        <p>
          Fintree does not take the right to ever force you to sell you home. As we have a share in your property, which
          we expect to appreciate over time, we are confident in making a profit over time, even if that takes a lot
          longer than both you and we would have initially expected. We offer various options for extensions.
        </p>
        <h4>Why should I use Fintree rather than a competitor or taking out a loan?</h4>
        <p>
          Anyone that helps you get into your home quicker or manage staying their more affordably is solving the same
          big problem that Fintree is so we applaud them.
        </p>
        <h5>We do however believe we are the best solution for the following reasons:</h5>
        <p>
          Taking out more loans with interest for something you cannot pay for all on your own now generally puts people
          into (even more) financial distress. Fintree products allow you to pay at times when it’s affordable for you,
          we don’t making things worse by charging you interest.
        </p>
        <p>
          Our competitors’ products are designed to stay as shared investors with you for a long time so they can get as
          much capital gains as possible. Fintree is designed to help you and get out of your property as quickly as
          possible, and then use that money to help the next person or family out. With Fintree you get to benefit from
          getting all of the capital gains for yourself as soon as possible.
        </p>
      </div>
    </div>
  );
};

FAQ.propTypes = {};

export default FAQ;
